
import React from 'react';
import { View } from 'react-native';
import get from 'lodash/get';
import { connect } from 'react-redux';
import getSelectedLocale from '../../../../common/selectors/getSelectedLocale';
import withRouterHOC from '../../../../common/components/WithRouteHOC';
import { Typography, useTheme } from '@hmsexp/component-library';

const TRANSLATIONS_FEATURE_NAME = 'property_onboarding';

const DesktopScreen = (props) => {

  const theme = useTheme();

  return (
      <View style={{backgroundColor:theme.palette.background, width:'100%', height:'100%'}}>
        <Typography
          variant={'h5'}
          fontWeightType={'regular'}
          textProps={{ style: { margin: 'auto', textAlign: 'center' } }}
          >
          {'Please open '}<Typography fontWeightType={'bold'} variant={'h5'}>
            {'partner.oyorooms.com'}
          </Typography>{' on your '}
          <Typography fontWeightType={'bold'} variant={'h5'}>{'mobile browser'}</Typography>
          {' to self onboard your property with us.'}
        </Typography>
      </View>
  );
}

const mapStateToProps = state => {
  const translations = get(state.translationsReducer, 'translations.data', {});
  return {
    language: getSelectedLocale(state),
    translations: translations[TRANSLATIONS_FEATURE_NAME]
  };
}

export default withRouterHOC(connect(mapStateToProps)(DesktopScreen));

